<template lang="pug">
    .products-template
        .products-template-title
            p  {{ lenguageSelected.content1 }}
            img(:src="image")
        .products-template-content
            .products-template-content-title.blue
                |   {{ lenguageSelected.content2 }}
            .about-smallcells-content-description
                p(v-for="item in lenguageSelected.content3")
                ul
                    li(v-for="item in lenguageSelected.content4")  {{ item }}
                p(v-for="item in lenguageSelected.content5")   {{ item }}
                .products-template-box
                    p(v-for="item in lenguageSelected.content6", style="text-align:left!important") {{ item }}  
                p   {{ lenguageSelected.content7 }}
</template>

<script>
import image from '@img/products/BannerSecundario_OpticalFiber.jpg'

export default {
    props: ["lang"],
    created: function(){
        this.$data.lenguage = this.lang
    },
    data: function(){
        return {
            image: image,
            lenguage: 'EN',
            lenguageEN: {
                content1: 'ATP is a carrier-neutral wholesale optical fiber operator in the Andean telecom market. The chief objective of our fiber business is to deploy and manage the infrastructure required for continued development of our region’s connectivity industries.',
                content2: 'Dark Fiber',
                content3: [
                    'Our optical fiber metro networks are designed to offer maximum flexibility and scale, suitable for everything from single-strand leasing to hyper-dense configurations across small, medium or long-distance deployments.',
                    'Operational Flexibility - Simple, Flexible and Cost Efficient',
                    'Our fiber product solutions include:'
                ],
                content4: [
                    'Fiber to the Tower',
                    'Fiber to the Pole',
                    'Fiber to the Small Cell',
                    'Fiber to the Home',
                    'Dark Fiber Leasing',
                    'Data Connectivity for Enterprise Clients'
                ],
                content5: [
                    'Flexible business terms that provide attractive “ownership economics”.',
                    'Lease or IRU - One of our defining features is our dark fiber offer, either in the form of lease or in the mode of Indefeasible Right of Use (IRU).',
                    'Alternatively, we offer a Private Dedicated Networks solution. If your network needs the security, scalability, and dependability of a private network, but you don’t want to assume the burden of owning and operating your own infrastructure, ATP’s private dedicated network solutions will meet your needs. We provide connectivity on dedicated fiber lines and components that allow you to connect high-bandwidth facilities within a metro area, or between cities.',
                ],
                content6: [
                    'Our solutions and services offer carriers a low-cost alternative.',
                    'ATP’s networks will reduce your overall costs of ownership, installation, maintenance, and management.'
                ],
                content7: 'To learn more about how our Optical Fiber solutions can address your needs, click the “Contact Us” button to your left.' 
            },


            lenguageES: {
                content1: 'ATP es un operador neutral de fibra óptica en los países andinos. El principal objetivo de nuestro negocio de fibra es desplegar y administrar la infraestructura requerida para apoyar el desarrollo continuo de la conectividad de nuestra región.',
                content2: 'Fibra Oscura',
                content3: [
                    'Nuestras redes metropolitanas de fibra óptica están diseñadas para ofrecer la máxima flexibilidad y escala, adecuadas para todo, con estructuras de negocio flexibles que permiten arrendamientos de un solo cable, hasta configuraciones hiperdensas en despliegues de corta, mediana o larga distancia.',
                    'Flexibilidad operativa: simple, flexible y rentable',
                    'Nuestras soluciones de productos de fibra incluyen:'
                ],
                content4: [
                    'Fibra a la torre',
                    'Fibra al poste',
                    'Fibra al Small Cell',
                    'Fibra hasta el hogar',
                    'Arrendamiento de fibra oscura',
                    'Conectividad de datos para clientes empresariales'
                ],
                content5: [
                    'Ofrecemos términos comerciales flexibles que proporcionan titulariad económica sobre el activo.',
                    'Una de las características diferenciadoras de nuestra oferta es el servicio de fibra oscura, ya sea en forma de arrendamiento o bajo el modo de Derecho Irrevocable de Uso (IRU por sus singlas en inglés – Indefeasible Right of Use).',
                    'Adicionalmente, ofrecemos una solución de Redes Privadas Dedicadas. Si su red necesita la seguridad, mayor escala y la confiabilidad de una red privada, pero prefiere no asumir la operación correspondiente, nuestras soluciones de Redes Privadas Dedicadas cubrirán sus necesidades. Ofrecemos conectividad en líneas de fibra dedicadas y componentes de red que le permiten interconectar instalaciones con altos requerimientos de ancho de banda dentro de un área metropolitano o entre varias ciudades.',
                ],
                content6: [
                    'Nuestros servicios de redes privadas y el arriendo de fibra óptica reducirán sus costos generales de propiedad-titularidad, instalación, mantenimiento, operación y administración.'
                ],
                content7: 'Para obtener más información sobre cómo nuestras soluciones de Fibra pueden satisfacer sus requerimientos y necesidades, seleccione el boton de la izquierda para ir a la sección de contacto.' 
            }
        }
    },
    computed: {
        lenguageSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.lenguageEN : this.$data.lenguageES
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/molecules/PmOpticalFiber.vue